<template>
  <div :style="backTopContainerStyle" v-show="show" @click="startScrollToTop">
    <slot>
      <img :class="imgCss" :style="imgStyle" v-if="imgCss || imgUrl" :src="imgUrl"/>
      <svg v-else :width="width" :height="height" viewBox="0 0 1024 1024">
        <template v-if="svgType === 'circle_border_arrow'">
          <path :fill="svgMajorColor"
                d="M512 960C264.576 960 64 759.36 64 512 64 264.64 264.576 64 512 64 759.424 64 960 264.64 960 512 960 759.36 759.424 960 512 960L512 960ZM512 0C229.216 0 0 229.12 0 512 0 794.88 229.216 1024 512 1024 794.784 1024 1024 794.88 1024 512 1024 229.12 794.784 0 512 0L512 0ZM540.128 302.72C532.448 295.04 521.952 292.8 512 294.72 502.048 292.8 491.552 295.04 483.872 302.72L302.88 483.84C290.368 496.32 290.368 516.48 302.88 529.28 315.328 541.76 335.616 541.76 348.128 529.28L480 397.12 480 736C480 753.6 494.304 768 512 768 529.696 768 544 753.6 544 736L544 397.12 675.872 529.28C688.384 541.76 708.64 541.76 721.12 529.28 733.632 516.48 733.632 496.32 721.12 483.84L540.128 302.72 540.128 302.72Z"
                p-id="4308"/>
        </template>
        <template v-else-if="svgType === 'circle_fill_arrow'">
          <path :fill="svgMajorColor"
                d="M540.5696 102.4c-225.83296 0-409.6 183.74656-409.6 409.6s183.76704 409.6 409.6 409.6c225.85344 0 409.6-183.74656 409.6-409.6S766.42304 102.4 540.5696 102.4zM704.77824 506.92096c-9.23648 10.87488-22.40512 16.4864-35.61472 16.4864-10.69056 0-21.44256-3.66592-30.24896-11.12064l-51.63008-43.84768 0 188.1088c0 25.8048-20.91008 46.71488-46.71488 46.71488s-46.71488-20.91008-46.71488-46.71488l0-188.1088-51.63008 43.84768c-19.6608 16.71168-49.152 14.29504-65.86368-5.36576-16.71168-19.68128-14.29504-49.152 5.36576-65.86368l128.59392-109.21984c17.44896-14.80704 43.04896-14.80704 60.49792 0l128.59392 109.21984C719.07328 457.76896 721.48992 487.23968 704.77824 506.92096z"
                p-id="3596"/>
        </template>
        <template v-else-if="svgType === 'rocket_smoke'">
          <!-- 火箭外形 -->
          <path :fill="svgMajorColor"
                d="M699.04725 764.206732c0 0 8.433763 28.641418 26.351337 30.120214 37.704182 3.109067 135.522993-64.001605 143.055614-161.879465 7.527486-97.87786-45.175187-154.349411-94.114117-188.230801C778.103827 146.819357 533.409177 11.291229 514.580192 0 499.52522 7.530054 251.061692 143.05048 254.83057 444.219248c-48.941497 33.88139-101.644171 90.352941-94.114117 188.230801 7.530054 97.87786 105.38224 165.383905 143.05048 161.879465 20.559383-1.91268 26.351337-30.120214 26.351337-30.120214l11.298931-52.702673c0 0 56.466416 82.825455 71.523956 82.825455l101.639036 0 101.646738 0c18.82385 0 71.523956-82.825455 71.523956-82.825455L699.04725 764.206732zM607.700743 766.11171l-92.28616 0L423.123288 766.11171c-13.478616 0-86.730403-111.982911-86.730403-111.982911s-32.145858 102.255201-45.9685 105.318056c-26.38728 5.845868-98.224453-48.733542-103.508071-129.096903C177.812473 491.879635 280.309005 458.991812 280.309005 458.991812c0-311.124973 221.100653-423.513526 234.586972-430.252834 16.849554 10.107678 233.90919 133.484513 233.90919 426.33505 43.809354 30.32817 96.019095 76.360854 96.019095 180.497927 0 44.245804-67.814127 127.037884-101.55688 124.162445-14.687841-1.252869-23.588862-26.962367-23.588862-26.962367l-29.799295-77.457115C689.881791 655.314917 624.550297 766.11171 607.700743 766.11171z"
                p-id="29686"/>
          <!-- 中间圆圈 -->
          <path :fill="svgMajorColor"
                d="M514.585327 230.127475c-63.434219 0-114.850647 51.418995-114.850647 114.84808 0 63.431652 51.416428 114.84808 114.850647 114.84808 63.426517 0 114.845512-51.418995 114.845512-114.84808C629.433407 281.546471 578.014411 230.127475 514.585327 230.127475zM514.585327 435.952364c-50.248281 0-90.979376-40.733662-90.979376-90.979376s40.731095-90.976809 90.979376-90.976809c50.243147 0 90.976809 40.731095 90.976809 90.976809S564.831041 435.952364 514.585327 435.952364z"
                p-id="29690"/>
          <!-- 底部三条竖线 -->
          <path :fill="svgMinorColor"
                d="M435.526183 824.442026c-11.291229 0-22.585026 11.291229-22.585026 22.590161l0 109.166522c0 11.291229 11.293797 22.590161 22.585026 22.590161 11.296364 0 22.590161-11.296364 22.590161-22.590161l0-109.166522C458.116343 835.733256 446.822547 824.442026 435.526183 824.442026z"
                p-id="29687"/>
          <path :fill="svgMinorColor"
                d="M518.346503 821.890075c-11.01909 0-22.048449 11.026792-22.048449 22.048449l0 158.015595c0 11.021657 11.029359 22.045881 22.048449 22.045881 11.021657 0 22.045881-11.024224 22.045881-22.045881l0-158.015595C540.392384 832.916867 529.36816 821.890075 518.346503 821.890075z"
                p-id="29688"/>
          <path :fill="svgMinorColor"
                d="M593.639337 828.203202c-11.296364 0-22.587593 11.296364-22.587593 22.590161l0 79.056577c0 11.291229 11.288662 22.590161 22.587593 22.590161 11.291229 0 22.585026-11.296364 22.585026-22.590161l0-79.056577C616.224363 839.499566 604.933133 828.203202 593.639337 828.203202z"
                p-id="29689"/>
          <!-- 左边尾巴 -->
          <path :fill="svgMinorColor"
                d="M236.294263 942.904943c-11.275825-5.247675-23.835328-8.194999-37.090585-8.194999C150.59337 934.707377 111.189598 974.111148 111.189598 1022.716322c0 0.428748 0.025674 0.852362 0.033376 1.28111l22.143441 0c-0.007702-0.428748-0.033376-0.852362-0.033376-1.28111 0-36.379427 29.488645-65.868072 65.868072-65.868072 11.933068 0 23.113901 3.188655 32.767158 8.736711 8.62118 5.892081 19.640269 16.695513 24.567025 24.721066-1.183551-5.245107-1.609732-18.187146 0.84466-33.601548 8.762384-41.090524 45.257342-71.916762 88.961435-71.916762 13.409298 0 26.130544 2.926785 37.591219 8.133382l0-25.676122c-11.781594-4.079528-24.420685-6.325964-37.591219-6.325964C294.339603 860.92158 250.427555 895.496156 236.294263 942.904943z"
                p-id="29692"/>
          <!-- 右边尾巴 -->
          <path :fill="svgMinorColor"
                d="M824.798889 934.707377c-13.255256 0-25.817327 2.947324-37.090585 8.194999-14.135859-47.408786-58.04534-81.983362-110.049692-81.983362-13.170534 0-25.809625 2.246436-37.591219 6.325964l0 25.676122c11.460675-5.206597 24.181921-8.133382 37.591219-8.133382 43.704092 0 80.19905 30.826237 88.961435 71.916762 2.454392 15.414402 2.028211 28.356441 0.84466 33.601548 4.926755-8.025553 15.945845-18.828985 24.567025-24.721066 9.653257-5.548055 20.831522-8.736711 32.767158-8.736711 36.379427 0 65.868072 29.488645 65.868072 65.868072 0 0.428748-0.025674 0.852362-0.033376 1.28111l22.143441 0c0.007702-0.428748 0.033376-0.852362 0.033376-1.28111C912.810402 974.111148 873.40663 934.707377 824.798889 934.707377z"
                p-id="29691"/>
        </template>
        <template v-else>
          <path :fill="svgMajorColor"
                d="M668.014286 719.767997s7.127328-42.600237-36.616965-94.623077c42.600237-119.335922 48.459688-228.103138 48.459688-228.103138s87.433328 20.066011 87.433328 106.410541c0 147.673317-99.276051 216.315674-99.276051 216.315674z m-241.152338-51.967582s-58.550511-187.91688-58.550511-266.044262c0-35.045167 3.867074-66.223261 10.035564-94.623077h266.947841c6.224772 28.462239 10.153244 59.70173 10.153244 94.623077 0 76.920904-58.310034 266.044262-58.310034 266.044262H426.861948z m84.896552-317.585125c-29.971615 0-54.31914 24.229844-54.31914 54.262858 0 30.089295 24.347524 54.43682 54.31914 54.43682 30.089295 0 54.380538-24.347524 54.380538-54.43682 0-30.033014-24.291243-54.262858-54.380538-54.262858zM500.094856 107.194394V33.175587h21.148669v72.145134c24.167422 17.645892 89.729627 73.65451 119.335922 181.574428H383.116631c28.703739-104.895025 90.873684-160.365384 116.978225-179.700755zM355.868033 719.767997s-99.158371-68.642356-99.15837-216.316697c0-86.34453 87.433328-106.410542 87.433328-106.410542s5.92085 108.767216 48.459688 228.103138c-43.806715 52.024887-36.734646 94.624101-36.734646 94.624101z m191.900612 10.871605l-17.763572-17.639752-18.853394 59.033511-22.472827-59.033511-15.350617 30.695093-22.478967-55.593156h121.692597l-24.77322 42.537815z"
                p-id="26979"/>
          <path :fill="svgMinorColor"
                d="M560.100508 957.956841c-2.784416 0-4.900613-2.116197-4.900614-4.832052V821.395606a4.879124 4.879124 0 0 1 4.900614-4.894474c2.654456 0 4.894474 2.240017 4.894473 4.894474v131.729183c0 2.715855-2.240017 4.832052-4.894473 4.832052zM517.679349 924.904051c-2.715855 0-4.894474-2.233877-4.894473-4.894473V788.348955c0-2.784416 2.177596-4.955872 4.894473-4.955872 2.778276 0 4.894474 2.171456 4.894474 4.955872v131.660623c0 2.660596-2.116197 4.894474-4.894474 4.894473zM475.320613 990.824413c-2.778276 0-4.949732-2.233877-4.949732-5.012154V854.145497c0-2.654456 2.171456-4.894474 4.949732-4.894473 2.660596 0 4.894474 2.240017 4.894473 4.894473v131.666762c0 2.778276-2.233877 5.012154-4.894473 5.012154z"
                p-id="26980"/>
        </template>
      </svg>
    </slot>
  </div>
</template>
<style>
</style>
<script>
  import Vue from 'vue'

  export default {
    props: {
      threshold: {  // 可滚动控件滚动偏移多少后才显示回到顶部组件，必须大于 100。默认值为 150
        type: Number,
        required: false,
        default: 150,
        validator (val) {
          return val >= 100
        }
      },
      animationTime: { // 滚动到顶部的动画时间，单位为毫秒，100 到 200 之间。默认值为 150
        type: Number,
        required: false,
        default: 150,
        validator (val) {
          return val >= 100 && val <= 200
        }
      },
      imgUrl: {  // 滚动到顶部控件为图片模式时图片的 url，如果设置了该属性，则会忽略 svg 开头的相关属性。默认值为 null
        type: String,
        required: false,
        default: null
      },
      imgCss: {  // 滚动到顶部控件为图片模式时图片的样式，如果设置了该属性，则会忽略 svg 开头的相关属性。默认值为 null
        type: String,
        required: false,
        default: null
      },
      svgMajorColor: {  // 滚动到顶部控件为 SVG 模式时的主要颜色。默认值为 #bfbfbf
        type: String,
        required: false,
        default: '#bfbfbf'
      },
      svgMinorColor: {  // 滚动到顶部控件为 SVG 模式时的次要颜色。默认值为 #bfbfbf
        type: String,
        required: false,
        default: '#bfbfbf'
      },
      svgType: {  // SVG 模式的样式类型，包括 circle_border_arrow、circle_fill_arrow、rocket_smoke、rocket。默认值为 rocket
        type: String,
        required: false,
        default: 'rocket'
      },
      right: {  // 滚动到顶部控件右边缘离浏览器右边缘的距离，单位为 px，但是开发者只需要写数字就行。默认值为 30
        type: Number,
        required: false,
        default: 30
      },
      bottom: { // 滚动到顶部控件下边缘离浏览器下边缘的距离，单位为 px，但是开发者只需要写数字就行。默认值为 60
        type: Number,
        required: false,
        default: 60
      },
      width: { // 滚动到顶部控件宽度，单位为 px，但是开发者只需要写数字就行。默认值为 48
        type: Number,
        required: false,
        default: 48
      },
      height: { // 滚动到顶部控件高度，单位为 px，但是开发者只需要写数字就行。默认值为 48
        type: Number,
        required: false,
        default: 48
      }
    },
    data () {
      return {
        show: false,
        intervalTime: 20,
        scrollableElement: null,
        scrollToTopTimer: Number.MIN_VALUE,
        addScrollListenerTimeout: Number.MIN_VALUE,
        addScrollListenerTimeoutCount: 0,
        backTopContainerStyle: {
          width: this.width + 'px',
          height: this.height + 'px',
          bottom: this.bottom + 'px',
          right: this.right + 'px',
          position: 'fixed',
          cursor: 'pointer',
          'z-index': 999
        },
        imgStyle: {
          width: this.width + 'px',
          height: this.height + 'px'
        }
      }
    },
    watch: {
      $route (to, from) {
        // 这里先清除滚动监听器「然后延时500毫秒，否则整个项目只添加一个 BgaBackTop 时可能会出现失效」
        this.removeScrollListener()
        setTimeout(this.addScrollListener, 500)
      }
    },
    methods: {
      clearTimer () {
        if (this.scrollToTopTimer !== Number.MIN_VALUE) {
          clearInterval(this.scrollToTopTimer)
          this.scrollToTopTimer = Number.MIN_VALUE
        }
        if (this.addScrollListenerTimeout !== Number.MIN_VALUE) {
          clearTimeout(this.addScrollListenerTimeout)
          this.addScrollListenerTimeout = Number.MIN_VALUE
        }
      },
      removeScrollListener () {
        this.show = false
        this.clearTimer()
        if (this.scrollableElement) {
          this.scrollableElement.removeEventListener('scroll', this.handleScrolling)
          this.scrollableElement = null
        }
      },
      addScrollListener () {
        this.removeScrollListener()
        this.scrollableElement = document.getElementsByClassName('bga-back-top')[0]
        if (this.scrollableElement) {
          this.scrollableElement.addEventListener('scroll', this.handleScrolling)
        } else if (this.addScrollListenerTimeoutCount < 6) {
          // 可能是在可滚动节点上用了 v-if 来判断某个对象（可能生产这个对象时需要从网络加载数据，会要好几秒的时间）是否为空导致获取不到该节点
          // 这里每 1.5 秒获取一次可滚动节点，一共 6 次，如果 6 次后还是获取不到可滚动节点的话就不会再获取了，触发路由发生变化
          this.addScrollListenerTimeout = setTimeout(this.addScrollListener, 1500)
          this.addScrollListenerTimeoutCount++
        }
      },
      handleScrolling (e) {
        if (e.target.scrollTop > this.threshold) {
          this.show = true
        } else {
          this.show = false
        }
      },
      startScrollToTop () {
        if (this.scrollableElement) {
          let scrollTop = this.scrollableElement.scrollTop
          let speed = this.intervalTime / this.animationTime
          this.scrollToTopTimer = setInterval(() => {
            if (this.scrollableElement) {
              scrollTop -= scrollTop * speed
              if (scrollTop <= 1) {
                scrollTop = 0
                this.clearTimer()
              }
              this.scrollableElement.scrollTop = scrollTop
            } else {
              this.clearTimer()
            }
          }, this.intervalTime)
        }
      }
    },
    created () {
      Vue.prototype.$bagBacktopInstance = this
    },
    destroyed () {
      Vue.prototype.$bagBacktopInstance = null
    },
    beforeDestroy () {
      this.removeScrollListener()
    },
    mounted () {
      this.$nextTick(() => {
        this.addScrollListener()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// node_modules/bga-back-top-vue/src/components/BgaBackTop.vue